// extracted by mini-css-extract-plugin
export var container = "_f2-0";
export var segment = "_f2-2";
export var segmentActive = "_f2-3";
export var track = "_f2-1";